import React from 'react'
import { Col, Row } from 'react-styled-flexboxgrid'
import { Content, PageHeaderCtr, SelectorContainer } from './style'
import PageHeader from '@components/PageHeader'
import Collapse from '@components/Collapse'
import CollapseHeader from './CollapseHeader'
import OnlinePlacementTest from '@components/OnlinePlacementTest'
import ProgramSelector from '@layouts/Dashboard/HeroBlock/ProgramSelector'
import PortalLearningPaths from '@classes/LearningPaths'
import PortalStudentProfile from '@classes/StudentProfile'
import Spacer from '@berlitz/spacer'

interface OPTPanelProps {
  LearningPaths?: PortalLearningPaths
  StudentProfile?: PortalStudentProfile
  activeMaterial?: string
}
const OPTPanel: React.FC<OPTPanelProps> = ({ LearningPaths, StudentProfile, activeMaterial }) => (
  <Content>
    <Row>
      <Col xs={12} md={12} lg={12}>
        <PageHeaderCtr>
          <PageHeader title="My learning path" noClock noHR={true} />
        </PageHeaderCtr>
        <SelectorContainer sm={12} md={5} lg={3}>
          <ProgramSelector
            defaultProgram={LearningPaths?.RecentLearningPath || activeMaterial}
            StudentProfile={StudentProfile}
            showCT={true}
            LearningPaths={LearningPaths}
          />
        </SelectorContainer>
        <Spacer size="md" />
      </Col>
    </Row>

    <Collapse activeIds={['opt']}>
      <Collapse.Panel key="opt" id="opt" header={<CollapseHeader title="Learning Path" />}>
        <OnlinePlacementTest showNotSetBanner />
      </Collapse.Panel>
    </Collapse>
  </Content>
)

export default OPTPanel
